import type { ProductLogoMediumProps } from '../types';

export function ProductLogoMediumStarlinks({
  size = 40,
  ...props
}: ProductLogoMediumProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 672 672"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <rect width="672" height="672" rx="100" fill="#1A2142" />
      <path
        d="M245.007 303.89C238.759 297.641 238.759 287.511 245.007 281.262L290.262 236.008C296.51 229.759 306.641 229.759 312.889 236.008L392.085 315.203C398.334 321.452 398.334 331.582 392.085 337.831L346.831 383.086C340.582 389.334 330.452 389.334 324.203 383.086L245.007 303.89Z"
        fill="white"
      />
      <path
        d="M216.723 479.252L284.605 411.37L216.723 343.488L148.841 411.37L216.723 479.252ZM307.233 400.056C313.383 406.207 313.48 416.12 307.521 422.388L307.233 422.684L228.037 501.88L227.741 502.168C221.572 508.032 211.874 508.032 205.705 502.168L205.409 501.88L126.213 422.684C119.965 416.435 119.965 406.305 126.213 400.056L205.409 320.86C211.658 314.612 221.788 314.612 228.037 320.86L307.233 400.056Z"
        fill="white"
      />
      <path
        d="M259.149 351.973L276.12 335.003L293.091 351.973L276.12 368.944L259.149 351.973Z"
        fill="white"
      />
      <path
        d="M344.002 267.12L360.973 250.15L377.943 267.12L360.973 284.091L344.002 267.12Z"
        fill="white"
      />
      <path
        d="M420.37 275.606L488.252 207.723L420.37 139.841L352.487 207.723L420.37 275.606ZM510.879 196.41C517.03 202.56 517.126 212.473 511.168 218.741L510.879 219.037L431.683 298.233L431.388 298.522C425.219 304.385 415.52 304.385 409.351 298.522L409.056 298.233L329.86 219.037C323.612 212.789 323.612 202.658 329.86 196.41L409.056 117.214C415.304 110.965 425.435 110.965 431.683 117.214L510.879 196.41Z"
        fill="white"
      />
      <path
        d="M165.811 377.429L182.782 360.458L267.635 445.311L250.664 462.282L165.811 377.429Z"
        fill="white"
      />
      <path
        d="M369.458 173.782L386.428 156.812L471.281 241.664L454.311 258.635L369.458 173.782Z"
        fill="white"
      />
      <path
        d="M425.839 368.84C425.839 362.212 431.212 356.84 437.839 356.84C444.467 356.84 449.839 362.212 449.839 368.84C449.839 378.295 447.977 387.657 444.359 396.393C440.74 405.128 435.437 413.066 428.751 419.752C422.066 426.438 414.127 431.741 405.392 435.359C396.657 438.978 387.294 440.84 377.839 440.84C371.212 440.84 365.839 435.467 365.839 428.84C365.839 422.212 371.212 416.84 377.839 416.84C384.143 416.84 390.385 415.599 396.208 413.187C402.032 410.774 407.323 407.238 411.781 402.781C416.238 398.324 419.774 393.033 422.186 387.209C424.598 381.385 425.839 375.143 425.839 368.84Z"
        fill="#57D7D9"
      />
      <path
        d="M485.735 368.736C485.735 362.108 491.108 356.736 497.735 356.736C504.362 356.736 509.735 362.108 509.735 368.736C509.735 386.07 506.321 403.235 499.687 419.25C493.054 435.265 483.33 449.816 471.073 462.074C458.816 474.331 444.265 484.054 428.25 490.688C412.235 497.321 395.07 500.736 377.735 500.736C371.108 500.736 365.735 495.363 365.735 488.736C365.735 482.108 371.108 476.736 377.735 476.736C391.918 476.736 405.962 473.943 419.065 468.515C432.168 463.087 444.074 455.132 454.102 445.103C464.131 435.074 472.087 423.169 477.514 410.066C482.942 396.963 485.735 382.918 485.735 368.736Z"
        fill="#57D7D9"
      />
    </svg>
  );
}
